module.exports = __webpack_public_path__ + "static/media/logo-equipe.fe558a8d.png";